(function() { module.exports = this["wp"]["components"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","components"]}
// module id = 2
// module chunks = 0 1